import { Box, Button, InputBase, Popover, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { darken } from "@material-ui/core/styles/colorManipulator"
import React from "react"
import { HexColorPicker } from "react-colorful"

const regColor = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/
const swatchWidth = 42
const swatchHeight = 34
const fallbackColor = "#FFEF35"

const useStyles = makeStyles((theme) => ({
  popover: {
    "& > .MuiPopover-paper": {
      overflow: "visible",
    },
  },
  root: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #d7dbe0",
    borderRadius: 8,
    padding: theme.spacing(0.8, 1.2),
    backgroundColor: "#ffffff",
  },
  label: {
    color: "#98a1ad",
    fontSize: "1rem",
    marginRight: theme.spacing(1.4),
    whiteSpace: "nowrap",
  },
  valueBox: {
    marginLeft: "auto",
    minWidth: 210,
    display: "flex",
    alignItems: "center",
    borderRadius: 10,

    backgroundColor: "#e7e7e7",
    paddingRight: theme.spacing(1.3),
  },
  swatchButton: {
    borderRadius: 8,
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    width: swatchWidth,
    height: swatchHeight,
    minWidth: swatchWidth,
    minHeight: swatchHeight,
    padding: 0,
    margin: 0,
  },
  input: {
    fontFamily: "700",
    fontSize: "1.2rem",
    color: "#2f3337",
    marginLeft: theme.spacing(1),
    "& input": {
      textTransform: "uppercase",
    },
  },
}))

function ColorPicker({ label, value, onChange }) {
  const classes = useStyles()
  const initialColor = regColor.test(value || "") ? value.toUpperCase() : fallbackColor
  const [color, setColor] = React.useState(initialColor)
  const [inputColor, setInputColor] = React.useState(initialColor)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSetColor = (val) => {
    const normalized = (val || "").toUpperCase()
    setInputColor(normalized)
    if (regColor.test(normalized) && normalized !== color) {
      setColor(normalized)
      if (typeof onChange === "function") {
        onChange(normalized)
      }
    }
  }

  const open = Boolean(anchorEl)
  const id = open ? "simple-popover" : undefined

  React.useEffect(() => {
    const normalized = regColor.test(value || "") ? value.toUpperCase() : fallbackColor
    if (normalized !== color) {
      setColor(normalized)
    }
    if (normalized !== inputColor) {
      setInputColor(normalized)
    }
  }, [value])

  const safeSwatchColor = regColor.test(color) ? color : fallbackColor
  const safeBorderColor = darken(safeSwatchColor, 0.2)

  return (
    <Box className={classes.root}>
      <Typography className={classes.label}>{label}</Typography>
      <Box className={classes.valueBox}>
        <Button onClick={handleClick} className={classes.swatchButton} style={{ backgroundColor: safeSwatchColor, borderColor: safeBorderColor }} />
        <InputBase value={inputColor} onChange={(e) => handleSetColor(e.target.value)} className={classes.input} />
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className={classes.popover}
      >
        <HexColorPicker color={safeSwatchColor} onChange={handleSetColor} />
      </Popover>
    </Box>
  )
}

export default ColorPicker
